import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLock, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  standalone: true,
  imports: [RouterModule, FontAwesomeModule]
})
export class UnauthorizedComponent {
  faLock = faLock;
  faArrowLeft = faArrowLeft;
}
